import React from 'react';
import { benefits } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function WhyStay() {
  return <section className="w-full bg-ocean-deep py-24 sm:py-28 lg:py-40" data-id="element-288" data-mp="1aporqu5jc77k">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-289" data-mp="wtusl2ukcw7n">
        <Reveal className="max-w-3xl" data-id="element-290" data-mp="11ql9fse6zvu4">
          <SectionLabel tone="light" data-id="element-291" data-mp="11rmv0qsu40q3">Why stay with us</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.75rem)] font-light leading-[1.08] text-ivory" data-id="element-292" data-mp="1pi0g1xd04zb6">
            A different way to
            <span className="block italic text-gold-soft" data-id="element-293" data-mp="1tkdjgf4a0l4s">experience Taveuni</span>
          </h2>
        </Reveal>

        <ul className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:mt-24 lg:grid-cols-4" data-id="element-294" data-mp="1kq8w45ocpru0">
          {benefits.map((benefit, i) => <Reveal as="li" key={benefit.title} delay={i * 0.08} data-id="element-295" data-mp="28es4smbbc6mm" data-mpi={i}>
              <div className="border-t border-ivory/15 pt-7" data-id="element-296" data-mp="2d69w0injasue">
                <span className="font-serif text-[13px] tracking-[0.2em] text-gold" data-id="element-297" data-mp="2d7uqy9drgdss">
                  0{i + 1}
                </span>
                <h3 className="mt-5 font-serif text-3xl font-light text-ivory" data-id="element-298" data-mp="1v0dm2r67vbjf">
                  {benefit.title}
                </h3>
                <p className="mt-4 text-[15px] leading-[1.8] text-ivory/60" data-id="element-299" data-mp="28sjzw6lwd6fp">
                  {benefit.description}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}